import { getContext } from '@fiverr-private/fiverr_context';
import { FILTER } from '../../../config/filters';
import { EXPERIMENTS } from '../../../../../shared/constants/experiments';
import { isInTestGroup } from '../../../../../shared/utils/experimentService';
import { getFilterById, getOptionById } from '../util';

export const decideOnSellerToggleFilters = (filters, { assumedLanguage } = {}) => {
    const { abTests = {}, countryCode } = getContext();

    const languageToggleAllocated = isInTestGroup(EXPERIMENTS.LIONS_SAME_LANGUAGE_SELLER_TOGGLE, abTests);

    const languageFilter = getFilterById(filters, FILTER.SELLER_LANGUAGE.ID);
    const languageOption = getOptionById(languageFilter, assumedLanguage);

    const locationFilter = getFilterById(filters, FILTER.SELLER_LOCATION.ID);
    const locationOption = getOptionById(locationFilter, countryCode);

    if (languageOption && languageToggleAllocated) {
        return { ...languageFilter, options: [languageOption], selectedValue: [assumedLanguage] };
    }

    if (locationOption) {
        return { ...locationFilter, options: [locationOption], selectedValue: [countryCode] };
    }
};
